import ModalBase, { type IModalBaseProps, type ModalBaseRefType } from "../../../../../Base/ModalBase";
import BoletoImportaRetornoForm, { type BoletoImportaRetornoFormRefType } from "./BoletoImportaRetornoForm";
import { useRef } from "react";

export default function BoletoImportarRetornoFormModal({
    title,
    propsButtonOpen,
    ...props
}:IModalBaseProps) {
    title = title ?? "Importar retorno";

    const refModal = useRef<ModalBaseRefType|null>(null);
    const refForm = useRef<BoletoImportaRetornoFormRefType|null>(null);
    
    return <ModalBase 
        ref={refModal} 
        title={title} 
        footer={<></>}
        propsButtonOpen={{
            ...propsButtonOpen,
            size : propsButtonOpen?.size ?? "middle"
        }}
        {...props}
    >
        <BoletoImportaRetornoForm 
            ref={refForm}
            onCancelar={() => refModal.current?.fechar()}
            onSuccess={() => refModal.current?.fechar()} 
        />
    </ModalBase>;
}